import React from "react";

interface AdminListSkeletonProps {
  count?: number;
}

/**
 * Purely presentational pulse placeholder shown while an admin list screen
 * first loads. Mirrors the generic admin card layout (avatar, title lines,
 * meta lines, trailing badge).
 */
const AdminListSkeleton: React.FC<AdminListSkeletonProps> = ({ count = 4 }) => {
  return (
    <div className="w-full pt-1">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="animate-pulse rounded-xl bg-white p-4 mb-3 shadow-sm"
        >
          <div className="flex items-center">
            <div className="h-11 w-11 rounded-full bg-[#E5E7EB] mr-3" />
            <div className="flex-1">
              <div className="mb-2 h-3.5 w-3/5 rounded-lg bg-[#E5E7EB]" />
              <div className="h-3 w-2/5 rounded-md bg-[#E5E7EB]" />
            </div>
            <div className="h-5 w-14 rounded-full bg-[#E5E7EB]" />
          </div>
          <div className="mt-3.5 h-3 w-full rounded-md bg-[#E5E7EB]" />
          <div className="mt-2 h-3 w-3/4 rounded-md bg-[#E5E7EB]" />
        </div>
      ))}
    </div>
  );
};

export default AdminListSkeleton;
